import type { AIModel, ModelTierDefault, ReasoningConfig } from "@/types";

/**
 * The effort allowlist of the model that will answer a chat (MHS-669): the selected agent's
 * pinned model, with a tier alias like "tier:thorough" resolved as the backend does, or the manual choice.
 */
export function chatReasoningConfig(
  agentModelId: string | undefined,
  manualModel: AIModel | undefined,
  models: readonly AIModel[],
  tierDefaults: readonly ModelTierDefault[],
): ReasoningConfig | null {
  if (!agentModelId) return manualModel?.reasoningConfig ?? null;
  const modelId = tierDefaults.find((td) => `tier:${td.tier}` === agentModelId)?.modelId ?? agentModelId;
  return models.find((m) => m.id === modelId)?.reasoningConfig ?? null;
}
